import React from "react";
import styles from "./OpportunitySidebar.module.scss";
import { FormGroup, Switch } from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { CurrencyInput } from "../../atoms/CurrencyInput";
import classnames from "classnames";
import moment from "moment";
import { ziplineFee, totalPrice, dateInputProps } from "./helpers";
import ProductSelect from "../VideoUploadSidebar/ProductSelect";

export function OpportunitySidebarForm({
  amount,
  onAmountChange,
  visibility,
  onToggleVisibility,
  isPercentage,
  onToggleIsPercentage,
  setSelectedProduct,
  expiresAt,
  onExpiresAtChange,
  productsLoading,
  availableProducts,
  selectedProduct,
  isAmountInvalid,
  fixedFee,
  variableFee
}) {
  return (
    <div className={styles.opportunitySidebar}>
      <span className="contentTitle">1. Choose a Product</span>
      <div className={styles.opportunity}>
        <div className={styles.opportunityInputs}>
          <ProductSelect
            loading={productsLoading}
            products={availableProducts}
            value={selectedProduct}
            onChange={setSelectedProduct}
            className={styles.selectBtn}
          />
        </div>
      </div>
      <span className="contentTitle">2. Opportunity Commission</span>
      <div className={styles.opportunity}>
        <div className={styles.opportunityInputs}>
          <FormGroup
            helperText={`Video Squirrel collects a ${(
              variableFee * 100
            ).toFixed(2)}% variable 
              fee and a $${fixedFee} fixed fee per sale. This amount is deducted from 
              the product price prior to payment.`}
            labelFor="fee-collection"
          >
            <Switch
              labelElement={
                <span className={styles.switchLabel}>
                  Percentage Commission
                </span>
              }
              large
              className={styles.switch}
              checked={isPercentage}
              onChange={onToggleIsPercentage}
            />
            <CurrencyInput
              placeholder="Commission"
              className={classnames(!amount && styles.invalid)}
              value={amount}
              onChange={onAmountChange}
              large
              leftIcon={isPercentage ? "percentage" : "dollar"}
              id="commission"
            />

            {isAmountInvalid && (
              <span className={styles.errorMsg}>
                Your commission amount must be less than the total price of your
                product.
              </span>
            )}

            {!(selectedProduct && selectedProduct.isDonation) && (
              <CurrencyInput
                placeholder="Fee Collection ($)"
                value={
                  selectedProduct &&
                  ziplineFee(selectedProduct.price, fixedFee, variableFee)
                }
                large
                disabled
                id="fee-collection"
              />
            )}
          </FormGroup>
          {!(selectedProduct && selectedProduct.isDonation) && (
            <CurrencyInput
              placeholder="Total Price ($)"
              value={
                selectedProduct &&
                totalPrice(
                  selectedProduct.price,
                  amount,
                  isPercentage,
                  fixedFee,
                  variableFee
                )
              }
              large
              disabled
              id="total-price"
            />
          )}
        </div>
      </div>

      <span className="contentTitle">3. Opportunity Visibility</span>
      <div className={styles.opportunity}>
        <div className={styles.opportunityInputs}>
          <FormGroup
            helperText="Private opportunities require you to approve or decline applications 
                from influencers before they can sell your product."
            labelFor="switch"
          >
            <Switch
              labelElement={
                <span className={styles.switchLabel}>Private Opportunity</span>
              }
              large
              className={styles.switch}
              checked={visibility}
              onChange={onToggleVisibility}
              id="switch"
            />
          </FormGroup>
        </div>
      </div>
      <span className="contentTitle">4. Expiration Date</span>
      <div className={styles.opportunity}>
        <div className={styles.opportunityInputs}>
          <DateInput
            {...dateInputProps({
              format: "YYYY-MM-DD",
              value: expiresAt,
              minDate: moment()
                .add(1, "day")
                .toDate()
            })}
            inputProps={{ large: true }}
            onChange={onExpiresAtChange}
          />
        </div>
      </div>
    </div>
  );
}
